import { Component, Input, OnInit } from '@angular/core';
import { CardTokenService, ProviderName, config } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TopUpAddressConfig, topUpAddressConfigDefault } from '@fgb/portal-component-library/src/lib/shared/top-up-address';
import { RegexUS } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { Router } from '@angular/router';

@Component({
  selector: 'fgbcl-add-new-card',
  templateUrl: './add-new-card.component.html',
  styleUrls: ['./add-new-card.component.scss'],
})
export class AddNewCardComponent implements OnInit {
  @Input() regex = RegexUS;
  @Input() provider = ProviderName.Sage;
  @Input() redirectUrl = '/cardtoken/result';
  @Input() failureUrl = '/cardtoken/result';
  @Input() topUpAddressConfig: TopUpAddressConfig = topUpAddressConfigDefault;
  @Input() showCloseBtn: boolean = false;
  @Input() version: number = 1;
  config: any = config;
  hideAddress: boolean = false;
  showCancelButton: boolean = false;
  loading: boolean = false;

  constructor(
    private cardTokenService: CardTokenService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {}

  private addNewCard(): void {
    this.loading = true;
    this.cardTokenService
      .addNewCardToken(
        this.provider,
        this.config.portalUrl + this.redirectUrl,
        'payment-gateway-area',
        this.config.portalUrl + this.failureUrl
      )
      .then(() => {
        this.loading = false;
      });
    this.showCancelButton = true;
  }

  openCardModal(content: any): void {
    this.showCancelButton = false;
    this.hideAddress = false;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'top-up-address-modal', centered: true });
  }

  submittedAddress(submitted: boolean): void {
    if (submitted) {
      this.hideAddress = true;
      this.addNewCard();
    }
  }

  cancel(): void {
    this.modalService.dismissAll();
  }

  /** The add card page reads the provider from PAYMENT_PROVIDER, so none is passed here. */
  navigateToAddCard(): void {
    this.router.navigate(['/payment/card']);
  }

  get isNewVersion() {
    return this.version === 2;
  }
}
